import { connect } from 'react-redux';
import ViewerWindow from '../../modules/ViewerWindow';
import { setIsLoading, setIsConfigSaved, setSnackbar } from '../common.duck';
import {
  setSelectedSize,
  openAlertDialog,
  savePartsConfiguration
} from '../customizer.duck';

const mapStateToProps = state => ({
  variantData: state.customizer.availableVariants,
  selectedVariant: state.customizer.selectedVariant,
  selectedSize: state.customizer.selectedSize,
  customizer: state.customizer,
  currentActiveParent: state.customizer.currentActiveParent,
  selectedCategory: state.customizer.selectedCategory,
  rotateTo: state.customizer.rotateTo,
  partsConfig: state.customizer.partsConfig,
  isDataReady: state.customizer.isDataReady,
  currentText: state.customizer.currentText,
  isConfigSaved: state.common.isConfigSaved,
  siteUrl: state.customizer.siteUrl,
  activeHotspot: state.customizer.activeHotspot,
  currentCustomizations: state.customizer.availableCustomizations
});

const mapDispatchToProps = dispatch => ({
  setIsLoading: bool => {
    dispatch(setIsLoading(bool));
  },
  setSelectedSize: size => {
    dispatch(setSelectedSize(size));
  },
  openAlertDialog: alertInfo => {
    dispatch(openAlertDialog(alertInfo));
  },
  saveConfig: () => {
    dispatch(setIsConfigSaved(true));
  },
  savePartsConfiguration: customizer => {
    dispatch(savePartsConfiguration(customizer, true));
  },
  setSnackbar: data => {
    dispatch(setSnackbar(data));
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(ViewerWindow);
